export default __webpack_public_path__ + "static/icons-a5721cb5cec30850968a7434a9e89047.svg";